// extracted by mini-css-extract-plugin
export default {"createElement":"create-element_createElement__-PJ-5","editElement":"create-element_editElement__a7McV","elementIcon":"create-element_elementIcon__1ELmw"};